import {
  getUnassignedTenderFolderURLs,
  newSingleUnassignedTenderFolderFileDownload,
} from '~src/services/api';
import { saveFromLink } from '~src/utils/downloader/shared/saveFromLink';
import { DownloadingState, useStore } from '~src/store';
import { message } from 'antd';

const createWorker = () => {
  return new Worker(
    URL.createObjectURL(
      new Blob(
        [
          `self.onmessage = async (event) => {
            const { file } = event.data;
            try {
              const response = await fetch(file.url);
              
              if (!response.ok) {
                throw new Error(\`HTTP \${response.status} - \${response.statusText}\`);
              }

              const blob = await response.blob();
              const url = URL.createObjectURL(blob);
              
              self.postMessage({ success: true, file, url });
            } catch (error) {
              console.error(\`Worker Error - File: \${file.file_name}, Error: \${error.message}\`);
              self.postMessage({ success: false, file, error: error.message });
            }
          };`,
        ],
        { type: 'application/javascript' }
      )
    )
  );
};

export const downloadUnassignedTenderFile = async (
  projectId,
  rootFolderId,
  folderId,
  registrationId,
  serial,
  onDownloadStarted
) => {
  useStore.getState().changeDownloadingState(DownloadingState.DOWNLOADING);

  if (!projectId) throw new Error(`No project id`);
  if (!registrationId) throw new Error(`No registrationId id`);

  const registrationKey = await newSingleUnassignedTenderFolderFileDownload(
    'registration key',
    {
      projectId: Number(projectId),
      rootFolderId: rootFolderId,
      folderId: folderId,
      registration_ids: registrationId,
      serial: serial,
    }
  );

  if (!registrationKey || registrationKey.length === 0) {
    useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
    setTimeout(() => useStore.getState().changeDownloadingActive(false), 3000);
    throw new Error('Registration key not found');
  }

  const fileUrl = await getUnassignedTenderFolderURLs(
    Number(projectId),
    registrationKey.map((key) => key.using_key)
  );

  if (!fileUrl || !fileUrl[0]?.url) {
    useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
    setTimeout(() => useStore.getState().changeDownloadingActive(false), 3000);
    throw new Error('File URL not found');
  }

  const worker = createWorker();
  const selectedFile = {
    file_name: registrationKey[0].file_name,
    url: fileUrl[0].url,
  };

  worker.postMessage({ file: selectedFile });
  worker.onmessage = (event) => {
    const { success, file, url, error } = event.data;
    if (success) {
      onDownloadStarted && onDownloadStarted();
      saveFromLink(url, file.file_name);
    } else {
      message.error(`ERROR: ${error}`);
    }
    worker.terminate();
  };

  useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
  setTimeout(() => {
    useStore.getState().changeDownloadingActive(false);
  }, 3000);
};

// future implementation for unnasigned folder's multiple files
// import {
//   getUnassignedTenderFolderURLs,
//   newSingleUnassignedTenderFolderFileDownload,
// } from '~src/services/api';
// import { DownloadingState, useStore } from '~src/store';
// import * as zip from '@zip.js/zip.js';
// import streamSaver from 'streamsaver';
//
// class ZipStream {
//   private zipWriter: zip.ZipWriter<WritableStream<any>> | null = null;
//   private writableStream: WritableStream<any> | null = null;
//   public successLog: string[] = [];
//   public errorLog: string[] = [];
//   private fileMap: Map<string, number> = new Map();
//   private currentFileAlreadyStreamed = 0;
//   private totalFiles = 0;
//   public totalSize = 0;
//   private startTime = 0;
//   public endTime = 0;
//   public isCancelled = false;
//
//   constructor(totalFiles: number, totalSize: number) {
//     this.totalFiles = totalFiles;
//     this.totalSize = totalSize;
//     useStore.getState().changeTotalFileSize(totalSize);
//   }
//
//   start() {
//     try {
//       useStore.getState().totalDownloadFiles(this.totalFiles);
//       this.startTime = performance.now();
//       this.writableStream = streamSaver.createWriteStream(
//         `C-WEB-Project-${Date.now()}.zip`
//       );
//       this.zipWriter = new zip.ZipWriter(this.writableStream);
//     } catch (error) {
//       this.isCancelled = true;
//     }
//   }
//
//   cancel() {
//     this.isCancelled = true;
//     this.writableStream = null;
//     this.zipWriter = null;
//     useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
//     setTimeout(() => useStore.getState().changeDownloadingActive(false), 3000);
//   }
//
//   getUniqueFileName(filePath: string): string {
//     let uniquePath = filePath;
//     let count = 1;
//
//     const match = filePath.match(/^(.*?)(\(\d+\))?(\.[^/.]+)?$/);
//     const baseName = match?.[1] || filePath;
//     const extension = match?.[3] || '';
//
//     while (this.fileMap.has(uniquePath)) {
//       uniquePath = `${baseName}(${count})${extension}`;
//       count++;
//     }
//
//     this.fileMap.set(uniquePath, count);
//     return uniquePath;
//   }
//
//   async addFile(name: string, blob: Blob) {
//     if (this.isCancelled || !this.zipWriter) return;
//
//     const uniqueName = this.getUniqueFileName(name);
//     try {
//       useStore.getState().changeDownloadingState(DownloadingState.FETCHING);
//       await this.zipWriter.add(uniqueName, new zip.BlobReader(blob));
//
//       this.currentFileAlreadyStreamed++;
//       useStore.getState().currentDownloadFile(this.currentFileAlreadyStreamed);
//
//       this.successLog.push(
//         `${uniqueName} - success (${(blob.size / 1024 / 1024).toFixed(2)} MB)`
//       );
//     } catch (error: any) {
//       this.errorLog.push(
//         `${uniqueName} (0.00 MB) - ERROR: ${error?.message} | D: Multiple`
//       );
//       useStore
//         .getState()
//         .addError(
//           `${uniqueName} (0.00 MB) - ERROR: ${error?.message} | D: Multiple`
//         );
//       this.isCancelled = true;
//     }
//   }
//
//   async finish() {
//     try {
//       if (!this.zipWriter || this.isCancelled) return;
//
//       if (this.endTime !== 0) {
//         return;
//       }
//
//       this.endTime = performance.now();
//       const totalSizeMB = (this.totalSize / 1024 / 1024).toFixed(2);
//       const timeTaken = (this.endTime - this.startTime) / 1000;
//       const speed = (this.totalSize / 1024 / 1024 / timeTaken).toFixed(2);
//       const totalErrors = this.errorLog.length;
//
//       const mergedLogs: string[] = [];
//       const successEntries = [...this.successLog];
//       const errorEntries = [...this.errorLog];
//
//       while (successEntries.length || errorEntries.length) {
//         if (successEntries.length) mergedLogs.push(successEntries.shift()!);
//         if (errorEntries.length) mergedLogs.push(errorEntries.shift()!);
//       }
//
//       const finalLog = [
//         ...mergedLogs,
//         `\n==== Summary V2 ====`,
//         `Total files - ${this.totalFiles}`,
//         `Total errors - ${totalErrors}`,
//         `Total size - ${totalSizeMB} MB`,
//         `Download speed - ${speed} MB/s`,
//         `Time taken - ${timeTaken.toFixed(2)} s`,
//       ];
//
//       if (totalErrors > 0) {
//         finalLog.push(`\n==== ${totalErrors} Errors ====`, ...this.errorLog);
//       }
//
//       const logBlob = new Blob([finalLog.join('\n')], { type: 'text/plain' });
//       await this.zipWriter.add('download_log.txt', new zip.BlobReader(logBlob));
//       await this.zipWriter.close();
//
//       useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
//     } catch (error) {
//       this.isCancelled = true;
//     }
//   }
// }
//
// const createWorker = () => {
//   return new Worker(
//     URL.createObjectURL(
//       new Blob(
//         [
//           `self.onmessage = async (event) => {
//             const { file } = event.data;
//             try {
//               const response = await fetch(file.url);
//
//               if (!response.ok) {
//                 throw new Error(\`HTTP \${response.status} - \${response.statusText}\`);
//               }
//
//               const blob = await response.blob();
//               self.postMessage({ success: true, file, blob });
//             } catch (error: any) {
//               console.error(\`Worker Error - File: \${file.file_name}, Error: \${error.message}\`);
//               self.postMessage({ success: false, file, error: error.message });
//             }
//           };`,
//         ],
//         { type: 'application/javascript' }
//       )
//     )
//   );
// };
//
// export const downloadUnassignedTenderFile = async (
//   files: any[],
//   projectId: number,
//   rootFolderId: number,
//   folderId: number,
//   fileVersionsContext: any,
//   onDownloadStarted?: () => void
// ) => {
//   console.log(`downloadUnassignedTenderFile ->`, files);
//   if (!files.length) throw new Error('No files selected');
//
//   const NUM_WORKERS = 5;
//   const totalFiles = files.length;
//   let totalSize = 0;
//   const fileQueue: any[] = [];
//
//   if (!projectId || !rootFolderId)
//     throw new Error('Invalid project or folder ID');
//
//   onDownloadStarted?.();
//   useStore.getState().changeDownloadingState(DownloadingState.DOWNLOADING);
//
//   for (const file of files) {
//     try {
//       if (!file.id) throw new Error(`No file's id`);
//
//       const selectedVersion = fileVersionsContext?.[file.id];
//       const selectedRevision = selectedVersion
//         ? selectedVersion.revision
//         : file.files?.[0]?.serial_number || 1;
//
//       const fileDetails =
//         file.files?.find((f: any) => f.serial_number === selectedRevision) ||
//         file.files?.[0];
//
//       if (!fileDetails || !fileDetails.registration_id) {
//         throw new Error(`File missing registration id`);
//       }
//
//       const registrationKeys = await newSingleUnassignedTenderFolderFileDownload(
//         'registration key',
//         {
//           projectId,
//           rootFolderId,
//           folderId,
//           registration_ids: fileDetails.registration_id,
//           serial: selectedRevision,
//         }
//       );
//
//       if (registrationKeys && registrationKeys.length > 0) {
//         for (const regFile of registrationKeys) {
//           fileQueue.push({
//             file: regFile,
//             fileName: regFile.file_name,
//           });
//           totalSize += regFile.file_size || 0;
//         }
//       }
//     } catch (error) {
//       console.error(`Error processing file ${file.id}:`, error);
//     }
//   }
//
//   if (fileQueue.length === 0) {
//     useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
//     setTimeout(() => useStore.getState().changeDownloadingActive(false), 3000);
//     return;
//   }
//
//   const zipStream = new ZipStream(totalFiles, totalSize);
//   zipStream.start();
//   if (zipStream.isCancelled) return;
//
//   const workers: Worker[] = [];
//   let activeWorkers = 0;
//
//   for (let i = 0; i < NUM_WORKERS; i++) {
//     workers.push(createWorker());
//   }
//
//   const assignFileToWorker = async (worker: Worker) => {
//     if (zipStream.isCancelled) return;
//
//     const nextFileObj = fileQueue.shift();
//     if (!nextFileObj) return;
//
//     activeWorkers++;
//
//     try {
//       const fileUrl = await getUnassignedTenderFolderURLs(projectId, [
//         nextFileObj.file.using_key,
//       ]);
//
//       if (!fileUrl[0] || !fileUrl[0].url) {
//         throw new Error('Invalid file URL received');
//       }
//
//       worker.postMessage({
//         file: { ...nextFileObj.file, url: fileUrl[0].url },
//       });
//
//       worker.onmessage = async (event) => {
//         const { success, file, blob, error } = event.data;
//         if (success) {
//           await zipStream.addFile(file.file_name, blob);
//         } else {
//           zipStream.errorLog.push(`${file.file_name} - ERROR: ${error}`);
//           useStore.getState().addError(`${file.file_name} - ERROR: ${error}`);
//         }
//
//         activeWorkers--;
//
//         if (fileQueue.length > 0) {
//           await assignFileToWorker(worker);
//         }
//
//         if (fileQueue.length === 0 && activeWorkers === 0) {
//           setTimeout(async () => {
//             if (zipStream.endTime === 0) {
//               await zipStream.finish();
//               workers.forEach((worker) => worker.terminate());
//             }
//           }, 500);
//         }
//       };
//     } catch (error: any) {
//       zipStream.errorLog.push(
//         `${nextFileObj.fileName} - ERROR: ${error.message}`
//       );
//       useStore
//         .getState()
//         .addError(`${nextFileObj.fileName} - ERROR: ${error.message}`);
//       activeWorkers--;
//       return await assignFileToWorker(worker);
//     }
//   };
//
//   for (const worker of workers) {
//     await assignFileToWorker(worker);
//   }
// };
